import { Reveal } from "./Reveal";

export const FinalStatement = () => (
  <section
    className="relative border-t border-dealer-ivory/10 py-32 sm:py-48"
    data-testid="final-statement-section"
  >
    <div className="mx-auto max-w-[1600px] px-6 sm:px-10">
      <Reveal>
        <p className="font-sans text-[11px] font-medium tracking-[0.4em] text-dealer-silver">
          REPRESENTATION&nbsp;&nbsp;STRATEGY&nbsp;&nbsp;LEVERAGE
        </p>
      </Reveal>

      <Reveal delay={0.15}>
        <span className="mt-10 block h-px w-24 bg-dealer-burgundybright" />
      </Reveal>

      <Reveal delay={0.25}>
        <p className="mt-10 font-serif text-xl italic text-dealer-silver sm:text-2xl">
          A DIFFERENT APPROACH.
        </p>
      </Reveal>

      <Reveal delay={0.35}>
        <h2 className="mt-14 font-serif text-4xl leading-[1.1] tracking-tight text-dealer-ivory sm:text-5xl lg:text-6xl">
          LET&rsquo;S CREATE
          <br />
          WHAT&rsquo;S NEXT.
        </h2>
      </Reveal>
    </div>
  </section>
);
